import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../app/stores/store';
import LoginForm from './LoginForm';

export default observer(function LoginPage() {
  const { userStore, modalStore } = useStore();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    userStore.setNavigateFunction(navigate);

    if (userStore.isLoggedIn) {
      const redirectUrl = userStore.getAndClearRedirectUrl();
      navigate(redirectUrl);
      return;
    }

    // Capture where the user came from (set by your redirect guard via router state)
    const state = location.state as { from?: string } | null;
    if (state?.from) {
      userStore.setPendingRedirectUrl(state.from);
    }

    modalStore.openModal(<LoginForm />);

    return () => {
      modalStore.closeModal();
    };
  }, [modalStore, userStore, navigate, location.state]);

  return null;
});